import { createTheme, adaptV4Theme } from '@mui/material/styles';
import lightTheme from './light';
import darkTheme from './dark';

const generalTheme = (
  primaryColor,
  secondaryColor,
  adminView = false,
  darkMode = false,
  partnerTheme = null,
  tertiaryColor = null,
  borderWidth = null,
  borderRadius = null,
  borderColor = null,
  boxShadow = null,
) => {
  // Select the base theme based on darkMode
  let baseTheme;
  if (partnerTheme) {
    // console.log('partner theme: ', partnerTheme);
    // console.log('here is primary color: ', primaryColor)
    baseTheme = darkMode
      ? darkTheme(primaryColor, secondaryColor, partnerTheme)
      : lightTheme(primaryColor, secondaryColor, partnerTheme);
  } else {
    // console.log( 'no partner theme: ', partnerTheme);
    baseTheme = darkMode
      ? darkTheme(primaryColor, secondaryColor, null, tertiaryColor, borderWidth, borderRadius, borderColor, boxShadow)
      : lightTheme(
          primaryColor,
          secondaryColor,
          null,
          tertiaryColor,
          borderWidth,
          borderRadius,
          borderColor,
          boxShadow,
        );
    // console.log('MAKING THEME WITH NO PARTNER THEME: ', baseTheme);
  }

  // Determine the final palette based on adminView and darkMode
  let finalPalette;
  if (adminView) {
    // Admin view
    finalPalette = {
      ...baseTheme.palette,
      primary: baseTheme.palette.admin,
      secondary: baseTheme.palette.admin,
    };
    // console.log('admin view palette: ', finalPalette);
  } else {
    //console.log('back to partner colors. check out palette: ', baseTheme.palette);
    // Non-admin view
    finalPalette = baseTheme.palette;
  }
  // console.log('here is the final palette in general theme: ', finalPalette);
  // console.log('please look here 435: ', baseTheme.styleOverrides);
  // console.log('Base theme:', baseTheme); // Debugging line
  // console.log('Style overrides:', baseTheme.styleOverrides); // Debugging line

  return createTheme(
    adaptV4Theme({
      themeName: darkMode ? 'Dark' : 'Light',
      palette: finalPalette,
      globalClasses: baseTheme.globalClasses,
      typography: baseTheme.typography,
      styleOverrides: {
        ...baseTheme.styleOverrides,
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: 'none', // Ensure buttons are not all caps
            },
          },
        },
      },
      breakpoints: baseTheme.breakpoints,
    }),
  );
};

export const dietQualityColors = [
  '#E57373', // Red
  '#FF8A65',
  '#FFB74D',
  '#FFD54F',
  '#EEDE62',
  '#DCE775',
  '#AED581',
  '#81C784',
  '#66BB6A',
  '#4CAF50', // Green
];

export const getDietQualityColor = (score, alpha = null) => {
  // ensure something is returned even if score is null, empty, not a number, etc.
  if ((score?.valueOf() ?? 0) === 0) {
    return '#FFFFFF';
  }

  const index = Math.min(Math.max(score - 1, 0), dietQualityColors.length - 1);
  return alpha ? `${dietQualityColors[index]}${alpha}` : dietQualityColors[index];
};

export const getStatusChipCss = () => {
  return {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '100px',
    lineHeight: '18px',
    resize: 'none',
    paddingTop: '4px',
    paddingBottom: '4px',
  };
};

export default generalTheme;
